export const globalStyles = {
  colors: {
    brand: {
      primary: {
        DEFAULT: "#5C2E85",
        50: "#CBB0E4",
        100: "#C1A1DE",
        200: "#AD82D4",
        300: "#9A64C9",
        400: "#8646BF",
        500: "#7138A3",
        600: "#5C2E85",
        700: "#3F205B",
        800: "#221132",
        900: "#050308",
      },
      secondary: {
        DEFAULT: "#FCD502",
        50: "#FEF3B7",
        100: "#FEF0A3",
        200: "#FEE97A",
        300: "#FEE352",
        400: "#FDDC29",
        500: "#FCD502",
        600: "#C4A602",
        700: "#8D7701",
        800: "#554801",
        900: "#1D1900",
      },
      "light-wisteria": {
        DEFAULT: "#CBB0E4",
        50: "#FFFFFF",
        100: "#FFFFFF",
        200: "#FFFFFF",
        300: "#F3EDF9",
        400: "#DFCEEE",
        500: "#CBB0E4",
        600: "#AF86D6",
        700: "#945CC7",
        800: "#783CB0",
        900: "#5B2E86",
      },
      clairvoyant: {
        DEFAULT: "#430A60",
        50: "#DBA6F6",
        100: "#D394F4",
        200: "#C46FF0",
        300: "#B54AEC",
        400: "#A625E8",
        500: "#9016CF",
        600: "#7712AA",
        700: "#5D0E85",
        800: "#430A60",
        900: "#20052D",
      },
      default: {
        50: "#F2F2F2",
      },
      text: {
        DEFAULT: "#FFFFFF",
        primary: "#858585",
      },
    },
    gray: {
      DEFAULT: "#E8E8E8",
      50: "#FFFFFF",
      100: "#F4F4F4",
      200: "#E8E8E8",
      300: "#CCCCCC",
      400: "#B0B0B0",
      500: "#949494",
      600: "#787878",
      700: "#5C5C5C",
      800: "#404040",
      900: "#242424",
    },
  },
  styles: {
    global: (props) => ({
      body: {
        margin: 0,
        fontFamily:
          '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
        fontSize: "0.875rem",
        fontWeight: 400,
        lineHeight: 1.5,
        textAlign: "left",
        color: "#333",
        overflowX: "hidden",
        bg: props.colorMode === "light" ? "#e8e8e8" : "#1F1F1F",
        letterSpacing: "-0.5px",
      },
      html: {
        fontFamily: "DM Sans",
      },
    }),
  },
};
